// reducer.js
import {
  SET_VALUE_ModeleAugCap,
  SET_TYPE_ModeleAugCap,
  SET_CURRENT_PAGE_ModeleAugCap,
  SET_ORDER_ModeleAugCap,
  SET_SORT_FIELD_ModeleAugCap,
  SET_ACTIF_ModeleAugCap,
  SET_CATEGORIE_ModeleAugCap,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleAugCap:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleAugCap:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleAugCap:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleAugCap:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleAugCap:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleAugCap:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleAugCap:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
